import axios from "axios";

const PUBLIC_SERVER_URL = process.env.NEXT_PUBLIC_API_URL;
const SERVER_URL = process.env.API_URL || PUBLIC_SERVER_URL;

const isServer = typeof window === "undefined";

const sanitizedBaseUrl = (isServer ? (SERVER_URL || PUBLIC_SERVER_URL) : (PUBLIC_SERVER_URL || SERVER_URL))
    ? (isServer ? (SERVER_URL || PUBLIC_SERVER_URL) : (PUBLIC_SERVER_URL || SERVER_URL)).replace(/\/+$/, "")
    : "";

const axiosInstance = axios.create({
    baseURL: sanitizedBaseUrl ? sanitizedBaseUrl + "/api" : "/api",
    headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "1",
    },
});

axiosInstance.interceptors.request.use(async (config) => {
    return config;
});

axiosInstance.interceptors.response.use(async (config) => {
    return config;
});

export { axiosInstance as axios };
